import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface SortOptionModel {
	id: number | string;
	text: string;
	key?: string;
}

@Injectable({
	providedIn: 'root',
})
export class SortService {
	selectedOptionSubject: Subject<SortOptionModel> = new Subject<SortOptionModel>();
	selectedOption$ = this.selectedOptionSubject.asObservable();

	defaultOption!: SortOptionModel;

	setDefaultOption(option: SortOptionModel) {
		this.defaultOption = option;
	}

	onSortOption(value: SortOptionModel) {
		this.selectedOptionSubject.next(value);
	}

	onSortBy(sortBy: any, array: any, key: any, search = '') {
		switch (sortBy) {
			case 0: // Most helpful
				return this.filterByPopularity(array);
			case 1: // Latest review
				return this.filterByDate(array, 'desc', key);
			case 2: // Earliest review
				return this.filterByDate(array, 'asc', key);
			case 3: // Highest ranked
				return this.filterByNumber(array, 'asc', key);
			case 4: // Lowest ranked
				return this.filterByNumber(array, 'desc', key);
			case 5: // filter by search term frequency in text
				return this.filterByMatch(array, key, search);
			default:
				return array;
		}
	}

	filterByNumber(array: any[], orderBy: string, key = 'rating') {
		if (array.length === 0) return array;
		const resultArray = [...array];
		if (orderBy === 'desc') {
			return resultArray.sort((a, b) => a[key] - b[key]);
		}
		return resultArray.sort((a, b) => b[key] - a[key]);
	}

	filterByDate(array: any[], orderBy: string, key = 'date') {
		if (array.length === 0) return array;
		let resultArray = [...array];
		resultArray = resultArray.sort((a, b) => {
			const reviewA = a[key].replace(/\s/, 'T');
			const reviewB = b[key].replace(/\s/, 'T');
			if (orderBy === 'desc') {
				return new Date(reviewB).valueOf() - new Date(reviewA).valueOf();
			}
			return new Date(reviewA).valueOf() - new Date(reviewB).valueOf();
		});
		return resultArray;
	}

	filterByPopularity(array: any[]) {
		if (!array || array.length === 0) return array;
		let resultArray = [...array];
		resultArray = resultArray.sort((a, b) => {
			if (a.dislikes === b.dislikes) {
				return b.likes - a.likes;
			}
			return a.dislikes > b.dislikes ? 1 : -1;
		});
		return resultArray;
	}

	filterByMatch(array: any[], key: string, search: string) {
		if (!array || array.length === 0 || !search || !key) return;
		const copy = [...array];
		const keys = key.split('_');
		const regex = new RegExp(search, 'gi');
		return copy.sort((a, b) => {
			return (
				(b[keys[0]]?.match(regex) || []).length +
				(b[keys[1]]?.match(regex) || []).length -
				((a[keys[0]]?.match(regex) || []).length +
					(a[keys[1]]?.match(regex) || []).length)
			);
		});
	}
}
